import React, { FC } from 'react';
import { FormSection } from 'omni-package-react-core';
import { useScopedSelector } from 'ia-react-core';
import UsernameControl from './UsernameControl';
import UsernameConfirmation from './UsernameConfirmation';
import { InvalidUsernameFormPageState } from '../../../../interfaces/InvalidUsernameFormPageState';

export interface UsernameSectionProps { }

const UsernameSection: FC<UsernameSectionProps> = () => {
  const isSubmitting: boolean = useScopedSelector((state: InvalidUsernameFormPageState) => state?.usernameForm?.isSubmitting);

  return (
    <FormSection>
      <UsernameControl isSubmitting={isSubmitting} />
      <UsernameConfirmation isSubmitting={isSubmitting} />
    </FormSection>
  );
};

export default UsernameSection;
